export default __webpack_public_path__ + "static/media/portfolio-8.f8346419.jpg";